import React, { ComponentType, ReactNode } from 'react';
import { Colorway, useTheme } from '@uds/theme-utils';
import { useBreakpoints } from '@ux/responsive';
import { ImagesWithAspectRatios } from 'core/ribbons/primitives';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import withLanguage from 'presentation/hocs/withLanguage';
import createImageAlt from 'presentation/utils/createImageAlt';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import createImageUrl from 'presentation/utils/createImageUrl';
import getActiveImageWithAspectRatios from 'presentation/utils/getActiveImageWithAspectRatios';
import { isNilOrEmpty } from 'presentation/utils/generalUtils';

import useStylesheet from './ItemHeader.stylesheet';

interface OuterProps {
  imageUrl: string | undefined;
  imageAspectRatio?: ImageAspectRatio;
  imagesWithAspectRatios?: ImagesWithAspectRatios;
  illustration: string | undefined;
  endorse: ReactNode;
  isEndorsed: boolean;
  colorway: Colorway;
}

export interface InnerProps extends OuterProps {
  currentLanguage: string;
}

const PureSalesboardItemHeader = ({
  endorse,
  isEndorsed,
  currentLanguage,
  imageUrl,
  illustration,
  colorway,
  imageAspectRatio,
  imagesWithAspectRatios,
}: InnerProps) => {
  const { theme } = useTheme();
  const breakpoints = useBreakpoints();
  const activeImage = getActiveImageWithAspectRatios(
    breakpoints,
    {
      imageUrl,
      imageAspectRatio,
    },
    imagesWithAspectRatios,
  );
  const hasBanner = !isNilOrEmpty(activeImage.url) || !isNilOrEmpty(illustration);
  const bannerUrl = createImageUrl(
    {
      illustration,
      imageUrl: activeImage.url,
    },
    theme,
    currentLanguage,
  );
  const { styles } = useStylesheet({
    colorway,
    imageAspectRatio: activeImage.imageAspectRatio,
    theme,
  });

  return (
    <div style={styles.root}>
      {hasBanner && (
        <div style={styles.bannerAspect}>
          <img
            loading="lazy"
            alt={createImageAlt({ imageUrl: bannerUrl })}
            src={urlLanguageParse(bannerUrl, currentLanguage)}
            style={styles.bannerImage}
          />
        </div>
      )}
      {isEndorsed && (
        <div style={styles.endorse}>
          <span style={styles.endorseText}>{endorse}</span>
        </div>
      )}
    </div>
  );
};

PureSalesboardItemHeader.displayName = 'SalesboardItemHeader';

export default withLanguage(PureSalesboardItemHeader) as ComponentType<OuterProps>;
